
export function mark(message) {
	if (__DEV__ && performance && 'mark' in performance) {
		console.log(`[mark] ${message}`);
		performance.mark(message);
	}
}
